export default __webpack_public_path__ + "static/media/Мэргэжлийн боловсрол_466.04eedb64.pdf";